import React, { useRef, useState, useEffect } from 'react';
import { useInView } from 'framer-motion';
import { COUNT_UP_DURATION } from './data';

/** Counts up to `target` once it scrolls into view. */
export const AnimatedCount = ({ target }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView || target <= 0) return;
    const startTime = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - startTime) / COUNT_UP_DURATION, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(target * eased));
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, target]);

  return <span ref={ref}>{value}</span>;
};
